"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelSnapshot = exports.ModelRegister = void 0;
exports.ModelRegister = {
    create: function () {
        return { __v: exports.ModelRegister.version() };
    },
    version: (function () {
        var last = Number.MIN_SAFE_INTEGER;
        return function () { return ++last; };
    })(),
};
var ModelSnapshotFactory = function () { return ({
    version: 0,
    instances: {},
    parentLinks: {},
    childLinks: {},
    states: {},
}); };
/*

Example model state in JSON form:

{
    version: 1,
    instances: {
        "root": { variant: "component", "type": "Root" },
        "test": { variant: "component", "type": "Rectangle" }
    },
    parentLinks: {
        "test": "root"
    },
    childLinks: {
        "root": { "test": 0.5 }
    },
    states: {
        "test": {
            "x": 50,
            "y": 50,
            "width": 100,
            "height": 100
        }
    },
}

*/
exports.ModelSnapshot = {
    /**
     * Converts the specified raw snapshot data into a ModelSnapshot structure.  This will affect (mutate) the input object tree.
     *
     * @param data the data
     */
    convert: function (data) {
        var e_1, _a, e_2, _b;
        try {
            // Add __v to all registers
            for (var _c = __values(Object.keys(data.states)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var k = _d.value;
                data.states[k]['__v'] = exports.ModelRegister.version();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _e = __values(Object.keys(data.childLinks)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var k = _f.value;
                data.childLinks[k]['__v'] = exports.ModelRegister.version();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return data;
    },
    empty: function () {
        return ModelSnapshotFactory();
    },
};
